export default ":host {\n  display: flex;\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 1rem;\n}\n";